"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AriaAttributes = {
    ActiveDescendant: "aria-activedescendant",
    AutoComplete: "aria-autocomplete",
    Controls: "aria-controls",
    Expanded: "aria-expanded",
    HasPopup: "aria-haspopup",
    Owns: "aria-owns",
    Pressed: "aria-pressed"
};
//# sourceMappingURL=Accessibility.js.map